// The size of a client as the sales plan counts it (« Tableau pilotage »):
// a key account, an SME or a very small business. A prospect gets the one
// chosen when it is created (crm.size, set by server/crm/crmRecordApi
// `setCompanySize`); a client takes its own from its ETP, the full-time
// temp workers of its timesheets, against the thresholds of the admin
// console (`sizeFromEtp`). Labels live in the locales (clientSizes).
export const CLIENT_SIZES = ['grand_compte', 'pme', 'tpe'];

export const clientSizeLabel = (language, size) =>
  size ? language.getValue(`clientSizes.${size}`, '') : '';

// `thresholds`: the ETP from which a client is a key account, then an SME;
// below, a very small business.
export const sizeFromEtp = (etp, thresholds) => {
  if (etp == null) return null;
  if (etp >= thresholds.grand_compte) return 'grand_compte';
  if (etp >= thresholds.pme) return 'pme';
  return 'tpe';
};

// « 3,4 ETP »
export const etpLabel = (etp) =>
  `${etp.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} ETP`;
